/*** Set Detail Page Banner Start ***/
function setDetailPageBanner(diamond_type){
  if(diamond_type == ''){
    $(".tps-color-diamond-detail-banner-section").hide();
  }else{
    $(".tps-white-diamond-detail-banner-section").hide();
  }
}
/*** Set Detail Page Banner End ***/

/*** Set Back To Search URL Start ***/ 
function changeBreadcrumUrl(diamond_type,gemstoneData) {
  // if(diamond_type == 'natural-white'){
  //   if(gemstoneData.fancyColor == ''){
  //     $("#tps_back_to_search").attr("href", tps_config.urls.loose_diamond);
  //     $("#tps_breadcrumbs_second_link").attr("href", tps_config.urls.loose_diamond);
  //   }else{
  //     $("#tps_back_to_search").attr("href", tps_config.urls.loose_color_diamond);
  //     $("#tps_breadcrumbs_second_link").attr("href", tps_config.urls.loose_color_diamond);
  //   }    
  // }else if(diamond_type == 'lab'){
  //   if(gemstoneData.fancyColor == ''){
  //     $("#tps_back_to_search").attr("href", tps_config.urls.lab_diamond);
  //     $("#tps_breadcrumbs_second_link").attr("href", tps_config.urls.lab_diamond);
  //   }else{
  //     $("#tps_back_to_search").attr("href", tps_config.urls.lab_color_diamond);
  //     $("#tps_breadcrumbs_second_link").attr("href", tps_config.urls.lab_color_diamond);
  //   }
  // } 
       
     $("#tps_back_to_search").attr("href", tps_config.urls.loose_gemstone);  
}
 
/*** End ***/

/*** Get Daimond ID From Url Start ***/
function getURLParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}    
/*** End ***/

/*** Get Diamond Detail Page Meta Title Information ***/
function getDiamondDetailMetaTitle(gemstoneData,diamondType,shopName) {
  var page_meta_title = gemstoneData.caratWeight+" "+translations.titleCarat+" "+gemstoneData.shape+" "+translations.titleShape+" "+diamondType+" "+translations.titleDiamond+" | "+gemstoneData.lab+" "+translations.titleCertified+" - "+shopName; 
  return page_meta_title;
}
/*** End ***/

/*** Get Diamond Detail Page Meta Descripion Information ***/
function getDiamondDetailMetaDesc(gemstoneData,diamondType,shopName) {
  var page_meta_description = translations.titleShopForA+" "+gemstoneData.caratWeight+ " "+translations.titleCarat.toLowerCase()+" "+gemstoneData.shape.toLowerCase()+" "+diamondType.toLowerCase()+" "+translations.titleDiamondAt+" "+shopName+". "+translations.titleThisDiamondIsCertifiedBy+" "+gemstoneData.lab+", "+translations.titleFeaturingA+" "+gemstoneData.clarity+" "+translations.titleAnd+" "+gemstoneData.color+" "+translations.titleColorRating+".";
  return page_meta_description;
}
/*** End ***/

/*** Get Diamond Description Information ***/
function getDiamondDesc(gemstoneData,diamondType) {  
  var dia_description = translations.titleThis+" " + gemstoneData.caratWeight + " "+translations.titleCarat.toLowerCase()+", " + gemstoneData.color + " "+translations.titleColorGemstoneRatedAsHaving+" " + gemstoneData.clarity + " "+translations.titleClarityWithA+" " + gemstoneData.shape.toLowerCase() + " "+translations.titleShapeSuppliedWithA+" " + gemstoneData.lab + " "+translations.titleGradingReport.toLowerCase()+".";
  return dia_description;
}
/*** End ***/

/*** Get Diamond Three C Information ***/
function getDiamondThreeCInfo(gemstoneData,diamondType) {
  var diamond_certificate_url = getCertificateUrl(gemstoneData);
  
  var diamond_threec_info = '<ul>';
  if(gemstoneData.color != ''){
     diamond_threec_info += '<li class="tps-three-c-item">' + gemstoneData.color + ' '+translations.titleColor+'</li>';
  }  
  diamond_threec_info += '<li class="tps-three-c-item">' + gemstoneData.clarity + ' '+translations.titleClarity+'</li>';
  if(gemstoneData.cut != '' && gemstoneData.cut != 'Na' && gemstoneData.cut != 'NA'){
    diamond_threec_info += '<li class="tps-three-c-item">' + gemstoneData.cut + ' '+translations.titleCut+'</li>';
  }
  diamond_threec_info += '<li class="tps-three-c-item"><span class="tps_'+gemstoneData.lab.toLowerCase()+'_icon" aria-hidden="true"></span><a href="'+diamond_certificate_url+'" target="_blank" rel="noopener noreferrer" aria-label="'+gemstoneData.lab+' '+translations.titleReport+'">' + gemstoneData.lab + ' '+translations.titleReport+'</a></li></ul>';
  return diamond_threec_info;
}
/*** End ***/

/*** Get Diamond Detail Information ***/
function getDiamondDetailInfo(gemstoneData) {  
  var diamondInformation = getGemstoneInformationLayout(gemstoneData);
  
  var detailInfo = '';  
  detailInfo += '<div class="tps-gemstone-details">';
  detailInfo += '<div class="tps-gemstone-detail-section-heading active"><h2>'+translations.titleGemstoneDetails+'</h2><span class="tps-tab-arrow tps-arrow-up"></span></div>';
  detailInfo += '<div class="tps-gemstone-details-info">';   
  detailInfo += diamondInformation;
  detailInfo += '</div>';
  detailInfo += '</div>';
  return detailInfo;
}
/*** End ***/

/*** Diamond detail Info Open Close ***/
$(document).on("click", ".tps-gemstone-detail-section-heading", function() {
  if(jQuery(this).hasClass('active')){
    jQuery(this).removeClass('active');
    jQuery('.tps-tab-arrow').addClass('tps-arrow-down').removeClass('tps-arrow-up');
    jQuery('.tps-tab-arrow').addClass('tps-arrow-down').removeClass('tps-arrow-up');
    jQuery('.tps-gemstone-details-info').slideUp('slow');
  }else{
    jQuery(this).addClass('active');
    jQuery('.tps-tab-arrow').addClass('tps-arrow-up').removeClass('tps-arrow-down');
    jQuery('.tps-gemstone-details-info').slideDown('slow');
  }    
});
/*** End ***/

/*** Get Diamond Grid View Gallery ***/
function getGridViewGallery(gemstoneData,imageUrls,threedEnable,handSliderEnable,canvasImagesEnable) {
  var diamond_type = getDiamondType(gemstoneData.gemstoneType);    
  var diamond_title = getGemstoneName(gemstoneData,diamond_type);
  var gemstone_type = gemstoneData.gemstoneType
  var diamondStockImage = [];
  var diamondHandSliderImage = [];

  //get diamond stock image url
  $.each(gemstoneImageUrl, function(i, diamondImage) {   
    if(gemstoneData.fancyColor == ''){
      var imageParam = gemstoneData.shape.toLowerCase()+'_generic';
    }else{
      var imageParam = gemstoneData.shape.toLowerCase()+'_'+gemstoneData.fancyColor.toLowerCase()+'_generic';
    }     
    
    if(diamondImage.includes(imageParam)){    
      diamondStockImage.push(diamondImage);
    }

    var handSliderDiamondImage = 'hand_slider_'+gemstoneData.shape.toLowerCase()+'_diamond';
    if(diamondImage.includes(handSliderDiamondImage)){    
      diamondHandSliderImage.push(diamondImage);
    }
  });
  
  var galleryHtml = '';  
  galleryHtml += '<div class="tps-main-slide tps-main-slide-image">';
  galleryHtml += '<div class="tps-slide">';
    if(gemstoneData.gemstoneImage != '' && gemstoneData.gemstoneImage != 'NA' && gemstoneData.gemstoneImage != 'N/A' && gemstoneData.gemstoneImage != 'None'){
      galleryHtml += '<img class="tps-gemstone-stock-image" src="'+gemstoneData.gemstoneImage+'" onerror="imgError(this,`'+diamondStockImage[0]+'`);" title="'+diamond_title+'" alt="'+diamond_title+'" height="400" width="400">';
    }else{         
      galleryHtml += '<img class="tps-gemstone-stock-image" src="'+diamondStockImage[0]+'" data-placeholder-img="" alt="'+diamond_title+'" title="'+diamond_title+'" width="400" height="400">';      
    }
  galleryHtml += '</div>';  
  galleryHtml += '</div>';   

  if(gemstoneData.gemstoneVideo != '' && gemstoneData.gemstoneVideo != 'None'){
    galleryHtml += '<div class="tps-main-slide tps-main-slide-video">';
    galleryHtml += '<div class="tps-slide">';     
    galleryHtml += getGallery360VideoLayout(gemstoneData);  
    galleryHtml += '</div>';
    galleryHtml += '</div>';   
  }

  if(threedEnable == 'true'){
    galleryHtml += '<div class="tps-main-slide tps-main-slide-threed-model">';
    galleryHtml += '<div class="tps-slide">';
    galleryHtml += getGalleryThreeDLayout(gemstoneData);
    galleryHtml += '</div>';
    galleryHtml += '</div>'; 
  }

  // if(handSliderEnable == 'true'){
  //   galleryHtml += '<div class="tps-main-slide tps-main-slide-hand-slider">';
  //   galleryHtml += '<div class="tps-slide">';
  //   galleryHtml += getGalleryHandSliderLayout(gemstoneData,imageUrls,diamondHandSliderImage[0]);
  //   galleryHtml += '</div>';
  //   galleryHtml += '</div>';  
  // }

  if(canvasImagesEnable == 'true'){
    galleryHtml += '<div class="tps-main-slide tps-main-slide-canvas-front">';
    galleryHtml += '<div class="tps-slide">';
    galleryHtml += '<canvas class="gallery-two tps-canvas-image-front" id="tps_canvas_image_front"></canvas>';
    galleryHtml += '</div>';
    galleryHtml += '</div>'; 
    
    galleryHtml += '<div class="tps-main-slide tps-main-slide-canvas-side">';
    galleryHtml += '<div class="tps-slide">';
    galleryHtml += '<canvas class="gallery-three tps-canvas-image-side" id="tps_canvas_image_side"></canvas>';
    galleryHtml += '</div>';
    galleryHtml += '</div>';      
  }

  var diamond_certificate_url = getCertificateUrl(gemstoneData); 
  galleryHtml += '<div class="tps-main-slide tps-main-slide-certificate">';
  galleryHtml += '<div class="tps-slide"><div class="tps-certificate-images"><a href="'+diamond_certificate_url+'" class="tps-gallery-slide-certificate-link" title="'+gemstoneData.lab+'" target="_blank">';
  // galleryHtml += getGalleryHandSliderLayout(gemstoneData,imageUrls,diamondHandSliderImage[0]);
  galleryHtml += imageUrls.certificateImage;
  galleryHtml += '</a></div>';
  galleryHtml += '<span class="tps-gallery-slide-lable">'+diamond_type+' '+translations.titleGemstone+'</span>';
  galleryHtml += '<a href="'+diamond_certificate_url+'" class="tps-gallery-slide-certificate-link" title="'+translations.titleViewCertificate+'" target="_blank">'+translations.titleViewCertificate+'</a>';
  galleryHtml += '</div>';
  galleryHtml += '</div>';
  
  return galleryHtml;
}
/*** End ***/

/*** Get Diamond Grid View Gallery ***/
function getThumbSliderGallery(gemstoneData,imageUrls,threedEnable,handSliderEnable,canvasImagesEnable) {
  var diamond_type = getDiamondType(gemstoneData.gemstoneType);    
  var diamond_title = getGemstoneName(gemstoneData,diamond_type);
  var mainImageGallery = getGridViewGallery(gemstoneData,imageUrls,threedEnable,handSliderEnable,canvasImagesEnable);
  var thumbImageGallery = getThumbnailGalleryLayout(gemstoneData,imageUrls,threedEnable,handSliderEnable,canvasImagesEnable);

  var galleryHtml = '';
  galleryHtml += '<div class="tps-main-image-slide">';
  galleryHtml += mainImageGallery;
  galleryHtml += '</div>';

  galleryHtml += '<div class="tps-thumb-image-slide">';
  galleryHtml += thumbImageGallery;
  galleryHtml += '</div>';    
  return galleryHtml;
}
/*** End ***/

/*** Get Diamond Gallery Thumbnail Layout ***/
function getThumbnailGalleryLayout(gemstoneData,imageUrls,threedEnable,handSliderEnable,canvasImagesEnable) {
  var diamond_title = getGemstoneName(gemstoneData,diamond_type);
  var diamondStockImage = [];
  var modalStockImage = [];

  //get diamond stock image url
  $.each(gemstoneImageUrl, function(i, diamondImage) {      
    if(gemstoneData.fancyColor == ''){
      var imageParam = gemstoneData.shape.toLowerCase()+'_generic';
    }else{
      var imageParam = gemstoneData.shape.toLowerCase()+'_'+gemstoneData.fancyColor.toLowerCase()+'_generic';
    }  
    
    if(diamondImage.includes(imageParam)){    
      diamondStockImage.push(diamondImage);
    }

    var modalImageParam = '3d_'+gemstoneData.shape.toLowerCase()+'_diamond';
    if(diamondImage.includes(modalImageParam)){    
      modalStockImage.push(diamondImage);
    }    
  });
  
  var galleryThumbHtml = '';
  galleryThumbHtml += '<div class="tps-thumb-slide tps-thumb-slide-image">';
  galleryThumbHtml += '<div class="tps-thumb">';
  if(gemstoneData.diamondImage != '' && gemstoneData.diamondImage != 'NA' && gemstoneData.diamondImage != 'None' && gemstoneData.diamondImage != 'N/A'){
    galleryThumbHtml += '<img src="'+gemstoneData.diamondImage+'" onerror="imgError(this,`'+diamondStockImage[0]+'`);" title="'+diamond_title+'" alt="'+diamond_title+'" height="auto" width="auto">';
  }else{      
    galleryThumbHtml += '<img class="tps-thumb-image" src="'+diamondStockImage[0]+'" data-placeholder-img="" alt="'+diamond_title+'" title="'+diamond_title+'" width="auto" height="auto">';           
  }
  galleryThumbHtml += '</div>';  
  galleryThumbHtml += '</div>';   

  if(gemstoneData.diamondVideo != '' && gemstoneData.diamondVideo != 'None'){
    galleryThumbHtml += '<div class="tps-thumb-slide tps-thumb-slide-image">';
    galleryThumbHtml += '<div class="tps-thumb">'; 
    galleryThumbHtml += '<span class="tps-video-play-icon"></span>';     
    galleryThumbHtml += '<img class="tps-thumb-image" src="'+diamondStockImage[0]+'" data-placeholder-img="" alt="'+diamond_title+'" title="'+diamond_title+'" width="auto" height="auto">';    
    galleryThumbHtml += '</div>';
    galleryThumbHtml += '</div>';  
  }

  if(threedEnable == 'true'){
    galleryThumbHtml += '<div class="tps-thumb-slide tps-thumb-slide-image">';
    galleryThumbHtml += '<div class="tps-thumb">';
    galleryThumbHtml += '<img src="'+modalStockImage[0]+'" title="'+diamond_title+'" alt="'+diamond_title+'" height="auto" width="auto">';
    galleryThumbHtml += '</div>';
    galleryThumbHtml += '</div>'; 
  }

  // if(handSliderEnable == 'true'){
  //   galleryThumbHtml += '<div class="tps-thumb-slide tps-thumb-slide-image">';
  //   galleryThumbHtml += '<div class="tps-thumb">';
  //   galleryThumbHtml += '<img src="'+imageUrls.handSliderImage+'" onClick="renderSliders(`'+gemstoneData.caratWeight+'`)" title="'+diamond_title+'" alt="'+diamond_title+'" height="auto" width="auto">';
  //   galleryThumbHtml += '</div>';
  //   galleryThumbHtml += '</div>';  
  // }

  if(canvasImagesEnable == 'true'){
    galleryThumbHtml += '<div class="tps-thumb-slide tps-thumb-slide-image">';
    galleryThumbHtml += '<div class="tps-thumb">';
    galleryThumbHtml += imageUrls.canvasFrontImage;
    galleryThumbHtml += '</div>';
    galleryThumbHtml += '</div>';  

    galleryThumbHtml += '<div class="tps-thumb-slide tps-thumb-slide-image">';
    galleryThumbHtml += '<div class="tps-thumb">';
    galleryThumbHtml += imageUrls.canvasSideImage;
    galleryThumbHtml += '</div>';
    galleryThumbHtml += '</div>';  
  }

  var diamond_certificate_url = getCertificateUrl(gemstoneData); 
  galleryThumbHtml += '<div class="tps-thumb-slide tps-thumb-slide-image">';
  galleryThumbHtml += '<div class="tps-thumb">';
  galleryThumbHtml += imageUrls.certificateImage;
  galleryThumbHtml += '</div>';
  galleryThumbHtml += '</div>';
  
  return galleryThumbHtml;
}
/*** End ***/

// function getDiamondThumbStockImage(gemstoneData) {
//   $.each(gemstoneImageUrl, function(i, diamondImage) {   
//     if(gemstoneData.fancyColor == ''){
//       var imageParam = gemstoneData.shape.toLowerCase()+'_generic.png';
//     }else{
//       var imageParam = gemstoneData.shape.toLowerCase()+'_'+gemstoneData.fancyColor.toLowerCase()+'_generic.png';
//     }     
    
//     if(diamondImage.includes(imageParam)){         
//       var thumbImageUrl = diamondImage;
//       return thumbImageUrl;
//     }
//   });
// }

/*** Get Diamond Gallery 360 Video HTML ***/
function getGallery360VideoLayout(gemstoneData) {
   var video_url = gemstoneData.gemstoneVideo;
  
   if(video_url != ''){
    var videoHtml = '';
    if (video_url.indexOf("mp4") > -1 || video_url.indexOf(".mov") > -1) {
      videoHtml ='<video class="tps-dia-gallery-video" controls autoplay playsinline>';
      videoHtml +='<source src="'+video_url+'" type="video/mp4">';
      videoHtml +='</video>';     
    }else{
       videoHtml ='<iframe class="tps-dia-gallery-video-iframe tps-gallery-video-iframe" id="tps_gemstone_video_iframe" src="'+video_url+'" scrolling="no"></iframe>';

       //set iframe width as per device
       if (video_url.indexOf("https://loupe360.com/diamond/") > -1){              
          video_url = video_url.replace('/500/500', '/resp/true/autoplay');
          videoHtml ='<iframe class="tps-dia-gallery-video-iframe" id="tps_gemstone_video_iframe" src="'+video_url+'" width="500px" height="500px" scrolling="no"></iframe>';
       }        
      
    }
    return videoHtml;
  }  
}
/*** End ***/

/*** Get Diamond 3D Model HTML ***/
function getGalleryThreeDLayout(gemstoneData) {
  var shape = gemstoneData.shape;
  var width = gemstoneData.width;
  var length = gemstoneData.length;
  var depth = gemstoneData.depth;  
  var deptPerc = gemstoneData.deptPerc; 
  var table = gemstoneData.tablePerc;
  var girdle = gemstoneData.girdle;
  if(gemstoneData.girdleMin != '' && gemstoneData.girdleMax != '' && gemstoneData.girdleMin != 0 && gemstoneData.girdleMax != 0){
    var girdle = gemstoneData.girdleMin+"-"+gemstoneData.girdleMax;
  }

  var threed_url = '';
  threed_url += 'https://php71.transpacific-software.com/3d_diamond/index.php?getShape='+shape.toLowerCase();
  threed_url += '&getWidth='+width;
  threed_url += '&getLength='+length;
  threed_url += '&getDepth='+deptPerc;
  threed_url += '&getTable='+table;
  if(girdle != '' && girdle != null){
    threed_url += '&getGirdle='+girdle;
  }else{
    threed_url += '&getGirdle=NA';
  }

  if(threed_url != ''){    
    theedHtml ='<iframe class="tps-dia-gallery-threed-model" src="'+threed_url+'" height="400px" width="400px" scrolling="no"></iframe>';	
    return theedHtml;
  }
}
/*** End ***/

/*** Get Gallery Hand Slider Layout ***/
function getGalleryHandSliderLayout(gemstoneData,imageUrls,handDiamondImage) {
  handSliderHtml = '';
  handSliderHtml += '<div class="tps-diamond-hand-slider">';
  handSliderHtml += '<img id="tps-gallery-thumb-white" class="tps-gallery-hand-slider-white" src="'+imageUrls.handSliderWhite+'" title="Hand slider white image" alt="Hand slider white image" height="auto" width="auto">';
  handSliderHtml += '<img id="tps-gallery-hand-diamond-image" class="tps-gallery-hand-diamond-image" src="'+handDiamondImage+'" title="Hand slider diamond" alt="Hand slider diamond" height="auto" width="auto">';
  handSliderHtml += '<img id="tps-gallery-thumb-black" class="tps-gallery-hand-slider-dark" src="'+imageUrls.handSliderDark+'" title="Hand slider dark image" alt="Hand slider dark image" height="auto" width="auto">';
  handSliderHtml += '</div>';  

  handSliderHtml += '<div class="tps-diamond-hand-carat-slider">';
  handSliderHtml += '<span class="left-slide">0.20 ct.</span>';
  handSliderHtml += '<span class="right-slide">10 ct.</span>';
  handSliderHtml += '<div id="hand-carat-slider" class="caratlearnmore"></div>';  
  handSliderHtml += '<div class="min-carat-detail" id="min_carat_detail"></div>';
  handSliderHtml += '</div>';

  handSliderHtml += '<div class="tps-diamond-hand-color-slider">';
  handSliderHtml += '<span class="left-slide">'+translations.titleLighter+'</span>';
  handSliderHtml += '<span class="right-slide">'+translations.titleDarker+'</span>';
  handSliderHtml += '<div id="hand-color-slider" class="handcolorslider"></div>';  
  handSliderHtml += '</div>';

  setTimeout(function(){
    hand_carat_slider_render(gemstoneData.caratWeight);
    hand_color_slider_render();
  }, 1000);
  
  return handSliderHtml;   
}
/*** End ***/

/*** Rendar Hand & Carat Slider Start ***/
function renderSliders(diamondCarat) {
    hand_carat_slider_render(diamondCarat);
    hand_color_slider_render();
}
/*** Rendar Hand & Carat Slider End ***/

/*** Gallery Hand Color Slider ***/
function hand_color_slider_render() {
  $("#hand-color-slider").slider({
          step:0.01,
          min: 0.00,
          max: 1.00,
          value: 0.50,
          slide: function(event, ui) {
             var diamondcarat = ui.value;             
             $('#tps-gallery-thumb-black').css('opacity', diamondcarat);              
          },
          change: function(event, ui) {            
            var diamondcarat = ui.value;
            $('#tps-gallery-thumb-black').css('opacity', diamondcarat);  
          },
  });
}
/*** End ***/

/*** Gallery Hand Carat Slider ***/
function hand_carat_slider_render(diamondCarat) {
  const dpiDesktop = 96;        // Common desktop DPI
  const dpiIpad = 264;          // iPad Pro PPI
  const dpiIpadMini = 326;      // iPad Mini PPI
  const dpiHighResPhone = 450;  // High-resolution phone (like iPhone)  
  var diamondcarat = diamondCarat;
      
  $("#hand-carat-slider").slider({
            step: 0.001,
            min: 0.20,
            max: 10,
            value: diamondcarat,
            create: function() {         
                var get_dpiDesktop = caratToPixelSize(diamondcarat, dpiDesktop);

                $('#tps-gallery-hand-diamond-image').css({
                  'width': get_dpiDesktop + 'px',  // Set width to diamond diameter
                  'height': get_dpiDesktop + 'px'  // Set height to diamond diameter (making it square)
                });
              
                jQuery('#min_carat_detail').appendTo(jQuery('#hand-carat-slider a').get(0));
                jQuery('#hand-carat-slider').slider("value", diamondcarat);  
            },
            slide: function(event, ui) {    
                var diamondcarat = ui.value; 
              
                var delay = function() {
                    var handleIndex = jQuery(ui.handle).data('index.uiSliderHandle');
                    jQuery('#min_carat_detail').html(ui.value.toFixed(2)+" ct.");
                };
                setTimeout(delay, 5);
         },
        change: function(event, ui) {              
                var diamondcarat = ui.value;

                var get_dpiDesktop = caratToPixelSize(diamondcarat, dpiDesktop);
                $('#tps-gallery-hand-diamond-image').css({
                  'width': get_dpiDesktop + 'px',  // Set width to diamond diameter
                  'height': get_dpiDesktop + 'px'  // Set height to diamond diameter (making it square)
                });
          
                var delay = function() {
                    var handleIndex = jQuery(ui.handle).data('index.uiSliderHandle');
                    jQuery('#min_carat_detail').html(ui.value.toFixed(2)+" ct.");                         
                };
                setTimeout(delay, 600);
         },
    });
}
/*** End ***/

/*** Function To Convert Carat Weight To Diamond Diameter In mm (adjusted for visual purposes) Start ***/
function caratToMm(caratWeight) {
    return Math.cbrt(caratWeight / 0.0061).toFixed(2); // Return the size in mm
}
/*** Function To Convert Carat Weight To Diamond Diameter In mm (adjusted for visual purposes) End ***/

/*** Function To Convert Millimeters To Pixels Based On Device DPI (or PPI) Start ***/
function mmToPixels(mm, dpi) {
    return ((dpi * mm) / 25.4).toFixed(2); // Return size in pixels rounded to 2 decimals
}
/*** Function To Convert Millimeters To Pixels Based On Device DPI (or PPI) End ***/

/*** Function To Convert Carats To Pixel Size Based On Device DPI Start ***/
function caratToPixelSize(caratWeight, dpi) {
    // Step 1: Convert carat to millimeters
    const mmSize = caratToMm(caratWeight);
    
    // Step 2: Convert millimeters to pixels based on device DPI
    let pixelSize = mmToPixels(mmSize, dpi);
    
    // Optional: Apply scaling factor for visual purposes
    // let scalingFactor = 2; // Adjust this factor based on the size you want
    // pixelSize *= scalingFactor;
    
    // return pixelSize;
    return pixelSize *= 1, pixelSize;
}
/*** Function To Convert Carats To Pixel Size Based On Device DPI End ***/

/*** Get Gallery Canvas Image Layout ***/
function getCanvasLayout(gemstoneData) {
    var shape = gemstoneData.shape;
    var gridle = gemstoneData.girdle;
    if(gridle == '' || gridle == 'undefined' || gridle == 'Undefined' || gridle == null   || gridle == "null" || gridle == undefined ){
      if(gemstoneData.girdleMin != '' && gemstoneData.girdleMax != '' && gemstoneData.girdleMin != 0 && gemstoneData.girdleMax != 0){
        gridle = gemstoneData.girdleMin+"-"+gemstoneData.girdleMax;
      }else{
        gridle = "-";
      }      
    }
      
   var height = gemstoneData.depth;
   var dia_length = gemstoneData.length;
   var dia_width = gemstoneData.width;
   var dia_carat = gemstoneData.caratWeight;
   var culet = gemstoneData.culet;
   var width = gemstoneData.width;
   var length = gemstoneData.length;
   var depth = gemstoneData.depth;  
   var deptPerc = gemstoneData.deptPerc; 
   var table = gemstoneData.tablePerc;

   if(shape=='Round'){
      var table_width='195';
      var table_height='38';
      var depth_width='310';
      var depth_height='130';
      var depth_per_width='80';
      var depth_per_height='150';
      var gridle_width='101';
      var gridle_height='210';
      var culet_width='190';
      var culet_height='220';
      var width_height='17';
      var width_width='194';
      var length_height='145';
      var length_width='65';
    }

    if(shape=='Princess'){
      var table_width='200';
      var table_height='35';
      var depth_width='315';
      var depth_height='147';
      var depth_per_width='70';
      var depth_per_height='160';
      var gridle_width='112';
      var gridle_height='210';
      var culet_width='220';
      var culet_height='210'; 
      var width_height='15';
      var width_width='185';
      var length_height='145';
      var length_width='45';
    }

    if(shape=='Cushion' || shape=='Cushion Modified' || shape == 'Cushion Brilliant'){ 
      var table_width='185';
      var table_height='32';
      var depth_width='290';
      var depth_height='155';
      var depth_per_width='60';
      var depth_per_height='155';
      var gridle_width='120';
      var gridle_height='220';
      var culet_width='210';
      var culet_height='215';    
      var width_height='19';
      var width_width='190';
      var length_height='145';
      var length_width='50';
    }

    if(shape=='Radiant'){
      var table_width='200';
      var table_height='34';
      var depth_width='310';
      var depth_height='147';
      var depth_per_width='85';
      var depth_per_height='160';
      var gridle_width='140';
      var gridle_height='220';
      var culet_width='210';
      var culet_height='215'; 
      var width_height='14';
      var width_width='190';
      var length_height='145';
      var length_width='48';
    }

    if(shape=='Asscher'){
      var table_width='200';
      var table_height='35';
      var depth_width='315';
      var depth_height='148';
      var depth_per_width='70';
      var depth_per_height='160';
      var gridle_width='112';
      var gridle_height='210';
      var culet_width='220';
      var culet_height='210'; 
      var width_width='180';
      var width_height='15';
      var length_height='145';
      var length_width='42';
    }

    if(shape=='Emerald'){
      var table_width='200';
      var table_height='40';
      var depth_width='300';
      var depth_height='145';
      var depth_per_width='50';
      var depth_per_height='145';
      var gridle_width='110';
      var gridle_height='200';
      var culet_width='210';
      var culet_height='205'; 
      var width_width='190';
      var width_height='12';
      var length_height='145';
      var length_width='60';
    }

    if(shape=='Oval'){ 
      var table_width='200';
      var table_height='47';
      var depth_width='305';
      var depth_height='140';
      var depth_per_width='60';
      var depth_per_height='140';
      var gridle_width='112';
      var gridle_height='200';
      var culet_width='220';
      var culet_height='195'; 
      var width_width='200';
      var width_height='17';
      var length_height='150';
      var length_width='80';
    }

    if(shape=='Pear'){
      var table_width='210';
      var table_height='45';
      var depth_width='310';
      var depth_height='140';
      var depth_per_width='60';
      var depth_per_height='140';
      var gridle_width='124';
      var gridle_height='200';
      var culet_width='245';
      var culet_height='195'; 
      var width_width='195';
      var width_height='15';
      var length_height='145';
      var length_width='85';
    }

    if(shape=='Marquise'){ 
      var table_width='200';
      var table_height='47';
      var depth_width='305';
      var depth_height='140';
      var depth_per_width='60';
      var depth_per_height='140';
      var gridle_width='120';
      var gridle_height='200';
      var culet_width='210';
      var culet_height='200'; 
      var width_width='192';
      var width_height='17';
      var length_height='145';
      var length_width='85';
    }

    if(shape=='Heart'){
      var table_width='210';
      var table_height='32';
      var depth_width='290';
      var depth_height='155';
      var depth_per_width='60';
      var depth_per_height='155';
      var gridle_width='132';
      var gridle_height='215';
      var culet_width='240';
      var culet_height='210'; 
      var width_width='185';
      var width_height='18';
      var length_height='145';
      var length_width='60';
    }

    if(shape=='Square'){
      var table_width='200';
      var table_height='43';
      var depth_width='300';
      var depth_height='145';
      var depth_per_width='50';
      var depth_per_height='145';
      var gridle_width='110';
      var gridle_height='200';
      var culet_width='210';
      var culet_height='205';
      var width_width='200';
      var width_height='17';
      var length_height='145';
      var length_width='65';
    }
   
    drawCanvasSide(shape,table,gridle,culet,deptPerc,table_width,table_height,depth_width,depth_height,depth_per_width,depth_per_height,gridle_width,gridle_height,culet_width,culet_height,width,height);
    drawCanvasFront(shape,table,gridle,culet,depth,dia_width,dia_length,table_width,table_height,depth_width,depth_height,depth_per_width,depth_per_height,gridle_width,gridle_height,culet_width,culet_height,width,height, width_height, width_width, length_width, length_height);
}
/*** End ***/

/*** Draw Diamond Canvas Side Image ***/
function drawCanvasSide(shape,table,gridle,culet,deptPerc,table_width,table_height,depth_width,depth_height,depth_per_width,depth_per_height,gridle_width,gridle_height,culet_width,culet_height,width,height) {

    var circle_canvas = document.getElementsByClassName("tps-canvas-image-side")[0]; 
    
    var context = circle_canvas.getContext("2d");
      
    var depth1;
    if(height==''){
      depth1 = width;
    } else {
      depth1 = height;	
    }
  
    if(culet==''){
      culet='None';
    }
  
    // if(gridle==''){
    //   gridle='';
    // }	
    
    // Fill Style
    context.fillStyle = "rgb(0,0,0,0.70)";
      
    // Begin path
    context.beginPath();

    var img = new Image();
    img.src = $(".tps-canvas-thumb-image-side").attr('src');    
    img.onload = function() {  
      context.canvas.height = this.height;
      context.canvas.width = this.width;
      context.drawImage(img, 0, 0);
      context.font = "10px open Be-Vietnam-Pro, arial"; 
      context.fillStyle = "#000000";
      context.fillText(table, table_width, table_height);
      context.fillText(deptPerc, depth_width, depth_height);
      context.fillText(gridle, gridle_width, gridle_height);
      // if(shape=='Marquise'){ 
      //   context.fillText(culet, culet_width, culet_height);
      // }
  };  
} 
/*** End ***/

/*** Draw Diamond Canvas Front Image ***/
function drawCanvasFront(shape,table,gridle,culet,depth,dia_width,dia_length,table_width,table_height,depth_width,depth_height,depth_per_width,depth_per_height,gridle_width,gridle_height,culet_width,culet_height,width,height, width_height, width_width, length_width, length_height) {

  var circle_canvas = document.getElementsByClassName("tps-canvas-image-front")[0];

  var context = circle_canvas.getContext("2d");

  var depth1;

  if(height==''){ 
    depth1=width;
  }else{ 
    depth1=height;   
  }  

  if(culet==''){ 
    culet='None'; 
  }

  if(gridle==''){ 
    gridle='-';
  } 

  // Fill Style
  context.fillStyle = "rgb(93,179,195,0.20)"; 
  context.beginPath();  
  
  var img = new Image();
  img.src =$(".tps-canvas-thumb-image-front").attr('src'); 
  img.onload = function() {             
    context.canvas.height = this.height;
    context.canvas.width = this.width;
    context.drawImage(img, 0, 0); 
    context.font = "50px/bold open sans, arial"; 
    context.fillStyle = "#000000";
    context.fillText(dia_width, width_width, width_height); 
    context.fillText(dia_length, length_width, length_height); 
  };
}
/*** End ***/

/*** Gallery Thumbnail Slider Script Code Start ***/
function galleryThumbnailSlider(verticalSlider){
    $('.tps-main-image-slide').slick({
       slidesToShow: 1,
       slidesToScroll: 1,
       infinite: true,
       arrows: true,       
       adaptiveHeight: true,
       asNavFor: '.tps-thumb-image-slide',
       draggable: false,
       lazyLoad: 'progressive',
   });

  if(verticalSlider == true){
      $('.tps-thumb-image-slide').slick({
         vertical: true,
         verticalSwiping: true,
         slidesToShow: 4,
         slidesToScroll: 1,
         infinite: false,
         asNavFor: '.tps-main-image-slide',        
         focusOnSelect: true,
         draggable: false, 
         arrows: true,
         lazyLoad: 'progressive',
     });
  }else{
      $('.tps-thumb-image-slide').slick({
         slidesToShow: 5,
         slidesToScroll: 1,
         infinite: true,
         asNavFor: '.tps-main-image-slide',
         dots: false,
         arrows: false,     
         // variableWidth: true,
         focusOnSelect: true,
         draggable: false,
         lazyLoad: 'progressive',
         responsive 		: [
		  		{
			      	breakpoint: 1440,
			      	settings: {
			        	slidesToShow 	: 4,
			        	slidesToScroll 	: 1,
			        	adaptiveHeight  : true,			        	
			      	}
			    },
		  		{
			      	breakpoint: 992,
			      	settings: {
			        	slidesToShow 	: 5,
			        	slidesToScroll 	: 1,
			        	adaptiveHeight  : true,			        	
			      	}
			    },
		  		{
			      	breakpoint: 768,
			      	settings: {
			        	slidesToShow 	: 5,
			        	slidesToScroll 	: 1,
			        	adaptiveHeight  : true,			        	
			      	}
			    },
			    {
			      	breakpoint: 640,
			      	settings: {
			        	slidesToShow 	: 4,
			        	slidesToScroll 	: 1,
			        	adaptiveHeight  : true,			        	
			      	}
			    },
			    {
			      	breakpoint: 581,
			      	settings: {
			        	slidesToShow 	: 4,
			        	slidesToScroll 	: 1,
			        	adaptiveHeight  : true,			        	
			      	}
			    },
		 	], 
     });
  }
   
}
/*** End ***/

/*** Diamond Four C's Section Script ***/
function diamondFourCSection(gemstoneData){
  var diamondType = gemstoneData.gemstoneType;
  var diamondcarat = parseFloat(gemstoneData.caratWeight);
  var diamondshape = gemstoneData.shape.toLowerCase();
  
  var carat_array = ['0.10-0.50','0.50-1.00','1.00-2.00','2.00-3.00','3.00-4.00','4.00-5.00','5.00-6.00','6.00-7.00','7.00-8.00','8.00-9.00','9.00-10.00'];
  
  $(".tps-carat-icon").addClass('tps-carat-icon-'+diamondshape);
  $(carat_array).each(function(index, caratvalue) { 
    var carat = caratvalue.split('-');
    var carat_min = parseFloat(carat[0]);
    var carat_max = parseFloat(carat[1]);
    carat_min = carat_min.toFixed(2);
    // console.log(carat_min,"carat_min")
    carat_max = carat_max.toFixed(2);
    // console.log(carat_max,"carat_max")
    
    if(diamondcarat == carat_min){
      var carat_min = carat_min.replace('.', '-');
      $(".tps-four-cs-carat-weight-ranges .tps-carat-"+carat_min).addClass('active');
      $(".tps-four-cs-carat-weight-ranges .tps-carat-"+carat_min+" .tps-carat-pointer-bx").html('<div class="tps-carat-val"><span>YOUR DIAMOND <br>'+diamondcarat+'Ct.</span></div>');
    }else if(diamondcarat == carat_max){
      var carat_max = carat_max.replace('.', '-');
      $(".tps-four-cs-carat-weight-ranges .tps-carat-"+carat_max).addClass('active');
      $(".tps-four-cs-carat-weight-ranges .tps-carat-"+carat_min+" .tps-carat-pointer-bx").html('<div class="tps-carat-val"><span>YOUR DIAMOND <br>'+diamondcarat+'Ct.</span></div>');
    }else if(diamondcarat >= carat_min && diamondcarat <= carat_max){
      var carat_min = carat_min.replace('.', '-');
      console.log(carat_min,"carat_min1");
      $(".tps-four-cs-carat-weight-ranges .tps-carat-"+carat_min).addClass('active'); 
      $(".tps-four-cs-carat-weight-ranges .tps-carat-"+carat_min).addClass('pointer'); 
      $(".tps-four-cs-carat-weight-ranges .tps-carat-"+carat_min+" .tps-carat-pointer-bx").html('<div class="tps-carat-val"><span>YOUR DIAMOND <br>'+diamondcarat+'Ct.</span></div>');
    }    
    
  });        
  $("#tps_dia_carat_weight").html(gemstoneData.caratWeight);

  if(gemstoneData.fancyColor == ''){    
     $("#tps_dia_color").html(gemstoneData.color);
     $(".tps-color-"+gemstoneData.color).addClass('active');
    // $(".tps-color-"+gemstoneData.color).addClass('pointer');
     $(".tps-four-cs-fancy-color-section").remove();
      // $(".tps-color-"+gemstoneData.color+ " .tps-new-color").html('<div class="tps-color-val"><span>YOUR DIAMOND COLOR <br>'+gemstoneData.color+'</span></div>');
  }else{
    console.log("fancy color:",gemstoneData.fancyColor)
    $("#tps_dia_fancy_color").html(gemstoneData.fancyColor);
    $(".tps-fancy-color-"+gemstoneData.fancyColor).addClass('active');
    // $(".tps-fancy-color-"+gemstoneData.fancyColor).addClass('pointer');
    $(".tps-four-cs-color-section").remove();
    // $(".tps-color-"+gemstoneData.color+ " .tps-new-color").html('<div class="tps-color-val"><span>YOUR DIAMOND COLOR <br>'+gemstoneData.fancyColor+'</span></div>');
  }    

  if(gemstoneData.shape == "Round"){
    var diamondCut = gemstoneData.cut;
    $("#tps_dia_cut").html(gemstoneData.cut);
    if (diamondCut.indexOf("Very ") >= 0){
      diamondCut = diamondCut.replace(' ','-');
      $(".tps-cut-"+diamondCut).addClass('active');
    }else{
      $(".tps-cut-"+diamondCut).addClass('active');
    }
  }else{
    $(".tps-four-cs-cut-section").remove(); 
    $(".tps-four-cs-clarity-section").removeClass("even");
    $(".tps-four-cs-clarity-section").addClass("odd");
  }      
  
  $("#tps_dia_clarity").html(gemstoneData.clarity);
  $(".tps-clarity-"+gemstoneData.clarity).addClass('active');
  // $(".tps-clarity-"+gemstoneData.clarity).addClass('pointer');
  // $(".tps-clarity-"+gemstoneData.clarity+ " .tps-new-clarity").html('<div class="tps-clarity-val"><span>YOUR DIAMOND CLARITY <br>'+gemstoneData.clarity+'</span></div>');
}
/*** End ***/

/*** Diamond Details C's Section Script ***/
function diamonddetailsFourCSection(gemstoneData){
  var diamondType = gemstoneData.gemstoneType;
  var diamondcarat = parseFloat(gemstoneData.caratWeight);
  var diamondshape = gemstoneData.shape.toLowerCase();
  
  // var carat_array = ['0.10-0.5','0.5-1','1-2','2-3','3-4','4-5','5-6','6-7','7-8','8-9','9-10'];
  // $(".tps-carat-icon").addClass('tps-carat-icon-'+diamondshape);
  // $(carat_array).each(function(index, caratvalue) { 
  //   var carat = caratvalue.split('-');
  //   var carat_min = parseFloat(carat[0]);
  //   var carat_max = parseFloat(carat[1]);
  //   carat_min = carat_min.toFixed(2);
  //   carat_max = carat_max.toFixed(2);
    
  //   if(diamondcarat == carat_min){
  //     var carat_min = carat_min.replace('.', '-');
  //     $(".tps-detail-cs-carat-weight-ranges .tps-carat-"+carat_min).addClass('active');
  //   }else if(diamondcarat == carat_max){
  //     var carat_max = carat_max.replace('.', '-');
  //     $(".tps-detail-cs-carat-weight-ranges .tps-carat-"+carat_max).addClass('active');
  //   }else if(diamondcarat >= carat_min && diamondcarat <= carat_max){
  //     var carat_min = carat_min.replace('.', '-');
  //     $(".tps-detail-cs-carat-weight-ranges .tps-carat-"+carat_min).addClass('active'); 
  //     $(".tps-detail-cs-carat-weight-ranges .tps-carat-"+carat_min).addClass('pointer'); 
  //     $(".tps-detail-cs-carat-weight-ranges .tps-carat-"+carat_min+" .tps-carat-pointer-bx").html('<div class="tps-carat-val"><span>'+diamondcarat+'</span></div>');
  //   }    
    
  // });        
  $("#tps_detail_dia_carat_weight").html(gemstoneData.caratWeight+' ct.');

  var carat_rounded = diamondcarat.toFixed(1);                 // Round to 1 decimal
  var carat_replaced = carat_rounded.replace('.', '-');
  $('.tps-carat-scale-'+carat_replaced).addClass('active');
  $('.tps-carat-scale-'+carat_replaced).css('display','block');
  $('.tps-carat-scale-'+carat_replaced).append('<div class="tps-carat-scale-tooltip"><span>YOUR DIAMOND <br>'+diamondcarat+'Ct.<strong class="tps-carat-scale-pointer"></strong></span></div>');
  $('#tps-carat-scale-tooltip-value').html(gemstoneData.caratWeight);

  // const element = document.querySelector('.tps-carat-scale-'+carat_replaced);
  // const div_element = document.querySelector('.tps-carat-scale-tooltip-mobile');
  // const pointer_element = document.querySelector('.tps-carat-scale-pointer');

  // if (element) {
  //   const left_position = element.getBoundingClientRect().left;
  //   div_element.style.left = left_position+'px'; // set to any pixel or percentage value
  //   pointer_element.style.left = left_position+'px'; // set to any pixel or percentage value
  // }
    
  var color_info_array = {"D": "Colorless","E": "Colorless","F": "Colorless","G": "Nearly Colorless","H": "Nearly Colorless","I": "Nearly Colorless","J":"Nearly Colorless","K":"Faint"};  
  if(gemstoneData.fancyColor == ''){
     $("#tps_detail_dia_color").html(gemstoneData.color);  
     $(".tps-detail-cs-color-icon").html("<span class='tps-detail-color-icon tps-detail-color-icon-"+gemstoneData.color+"' aria-label='Color: "+gemstoneData.color+"' aria-hidden='true'></span>");   
     $(".tps-detail-color-info-value").html("<span class='tps-detail-color-info tps-detail-color-info-"+gemstoneData.color+"'>"+color_info_array[gemstoneData.color]+"</span>");    
     $(".tps-detail-cs-fancy-color-section").remove();  
  }else{
    $("#tps_detail_dia_fancy_color").html(gemstoneData.fancyColor);  
    $(".tps-detail-cs-fancy-color-icon").html("<span class='tps-detail-fancy-color-icon tps-detail-fancy-color-icon-"+gemstoneData.fancyColor+"' aria-label='Fancy Color: "+gemstoneData.fancyColor+"' aria-hidden='true'></span>");   
    $(".tps-detail-cs-color-section").remove();
  }    

  if(gemstoneData.shape == "Round"){
    var diamondCut = gemstoneData.cut;
    $("#tps_detail_dia_cut").html(gemstoneData.cut);
    if (diamondCut.indexOf("Very ") >= 0){
      diamondCut = diamondCut.replace(' ','-');
      // $(".tps-detail-cut-"+diamondCut).addClass('active');
      $(".tps-detail-cut-"+diamondCut).show();
    }else{
      $(".tps-detail-cut-"+diamondCut).show();
    }
  }else{
    $(".tps-detail-cs-cut-section").remove(); 
  }      
  
  $("#tps_detail_dia_clarity").html(gemstoneData.clarity);
  $(".tps-detail-cs-clarity-icon").html("<span class='tps-detail-clarity-icon tps-detail-clarity-icon-"+gemstoneData.clarity+"' aria-label='Clarity: "+gemstoneData.clarity+"' aria-hidden='true'></span>");   
  
  $("#tps_dia_ratio").text(gemstoneData.ratio);
  $("#tps_dia_measurement").html(gemstoneData.measurement);

  $("#tps_dia_cert").html(gemstoneData.lab);
  $(".tps-cert-"+gemstoneData.lab).show();
  var diamond_certificate_url = getCertificateUrl(gemstoneData);
  $("#tps_cert_url").attr('href',diamond_certificate_url);
  

  var yourDiamondInfo = $(".tps-detail-cs-section").html();
  $("#tps_your_diamond_details_info_section").html(yourDiamondInfo);

  var diamondType = getDiamondType(gemstoneData.gemstoneType);
  $(".tps-section-label").html(diamondType+' '+translations.titleDiamond);
}
/*** End ***/

/*** Loose Diamond Add To Cart Start ***/
function buyLooseDiamond(diamond_type){    
  
  jQuery("#tps_buy_loose_diamond").addClass('tps-loading');
  var gemstone_image = jQuery('.tps-gemstone-stock-image').attr('src');
      
  //query parameters for graphql diamond add to cart call
  var postdata = JSON.stringify({ query:`{
                  ${gemstoneAddToCart}(gemstoneId: "` +
              gemstone_id +
              `", currencyFlag:"GBP",
              gemstoneImage:"` +
              gemstone_image +
              `")
                  {      
                    status
                     code
                     message                       
                     productId
                     variantId                     
                  }
                  }
                  `});     

     jQuery.ajax({
      url:api,
      contentType: "application/json",
      type:'POST',
      data: postdata,
      success: function(response) { 
        console.log(response);        
          var variant_id = response?.data?.gemstoneAddToCart?.variantId;        
        
        setTimeout(function(){ 
          
            var productSku = [];
            
            jQuery.getJSON('/cart.js', function(cart) {
             if(cart.items != '' ){                     
               $(cart.items).each(function(index, value) { 
                   var str = "-";   
                   var sku = value.sku;
                   
                   if(sku.indexOf(str) != -1){                  
                     sku = sku.split('-');
                     sku = sku[2];                       
                   }else{
                     var sku = value.sku;                   
                   }
                   productSku.push(sku);                                    
               });

               jQuery("#tps_buy_loose_diamond").removeClass("tps-loading");                
                               
               setTimeout(function(){ 
                if($.inArray(gemstone_id, productSku)!=(-1)){ 
                  alert(translations.titleProductAlreadyInCart);
                  jQuery("#tps_buy_loose_diamond").removeClass("tps-loading");
                }else{                        
                  addtocart(variant_id);
                }
              }, 50);                    
             }else{
               addtocart(variant_id);
             }              
            });                                  
          
        }, 1500); 
      },
      error: function (xhr, ajaxOptions, thrownError) {
         alert(xhr.status);
         alert(thrownError);           
          jQuery("#tps_buy_loose_diamond").removeClass('tps-loading');
       }
    }); 
}
  
function addtocart(add_id){   
  jQuery("#tps_buy_loose_diamond").removeClass('tps-loading');
  jQuery.post('/cart/add.js', {
    quantity:1,
    id: add_id,
  });
 
  setTimeout(function(){
    window.location.href = "/cart";
  }, 1000);   
}
function createDiamondProduct(diamond_type){    
 
  if(diamond_type == 'white'){
    var diamondAddToCart = naturalDiamondAddToCart;
  }else{
    var diamondAddToCart = labDiamondAddToCart;
  }
  jQuery("#tps_add_diamond_to_wishlist").addClass('tps-loading');
  var gemstone_image = jQuery('.tps-gemstone-stock-image').attr('src');
      
  //query parameters for graphql diamond add to cart call
  var postdata = JSON.stringify({ query:`{
                  ${gemstoneAddToCart}(gemstoneId: "` +
              gemstone_id +
              `",diamondType:"` +
              diamond_type +
              `")
                  {      
                    status
                     code
                     message                       
                     productId
                     variantId                     
                  }
                  }
                  `});     

     jQuery.ajax({
      url:api,
      contentType: "application/json",
      type:'POST',
      data: postdata,
      success: function(response) { 
        if(diamond_type == 'white'){
          var productId = response.data.naturalDiamondAddToCart.productId;  
        }else{
          var productId = response.data.diamondAddToCart.productId;       
        }
        
        setTimeout(function(){ 
            addRemoveProductToWishlist(productId,'diamond');
            jQuery("#tps_add_diamond_to_wishlist").removeClass('tps-loading');
            
        }, 1500); 
      },
      error: function (xhr, ajaxOptions, thrownError) {
         alert(xhr.status);
         alert(thrownError);           
         jQuery("#tps_add_diamond_to_wishlist").removeClass('tps-loading');
       }
    }); 
}
/*** End ***/